<template>
  <span>
    {{ messageParts[0] }}
    <span role="button" class="redirect" @click="redirect()">
      {{ replaceText }}
    </span>
    {{ messageParts[1] }}
  </span>
</template>

<script>
export default {
  name: "ToastWithLink",

  props: {
    message: {
      type: String,
      required: true
    },

    replaceText: {
      type: String,
      required: true
    },

    redirect: {
      type: Function,
      required: true
    }
  },

  data() {
    return {};
  },

  computed: {
    messageParts() {
      return this.message.split("(LINK)");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables";

.redirect {
  cursor: pointer;
  text-decoration: underline;
  color: $green-lawn;
}
</style>
